import { API_RESOURCE } from '@/constants/api.constant'
import { useCrud } from '@/hooks/useCrud'
import { createOptions } from '@/utils/arrayHelper'
import { camelToWords } from '@/utils/stringHelper'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import SystemVariableService from './systemVariable.service'

const useSystemVariable = () => {
  const service = new SystemVariableService()
  const baseCrud = useCrud(API_RESOURCE.SYSTEM_VARIABLE, service)

  const queryClient = useQueryClient()

  const useUploadSystemVariables = (type) => {
    return useMutation({
      mutationFn: (file) => service.uploadSystemVariables({ type, file }),
      onSuccess: (res) => {
        toast.info(`Successfully Upload  ${camelToWords(API_RESOURCE.SYSTEM_VARIABLE)}`)

        queryClient.invalidateQueries(baseCrud.queryKey.lists())
      },
    })
  }

  const useFetchAllSystemVariables = (type, parameter) => {
    const { page, pageSize, sortBy = '', orderBy = 1, filters = {} } = parameter

    return useQuery({
      queryKey: [...baseCrud.queryKey.list({ page, pageSize, filters: { ...filters, type: type }, sortBy, orderBy })],
      queryFn: () => service.fetchAll({ page, pageSize, filters: { ...filters, type: type }, sortBy, orderBy }),
      placeholderData: [],
    })
  }

  const useSystemVariableOptions = (type, { status = 'active', valueKey = 'name', labelKey = 'name', ...rest }) => {
    return useQuery({
      queryKey: [...baseCrud.queryKey.list({ page: 1, pageSize: 0, filters: { status, ...rest, type: type } })],
      queryFn: () => service.fetchAll({ page: 1, pageSize: 0, filters: { status, ...rest, type: type } }),
      placeholderData: [],
      select: (data) => {
        const options = createOptions(data?.data, labelKey, valueKey)

        return options
      },
    })
  }

  return {
    //Base CRUD
    useFetchAllSystemVariables: useFetchAllSystemVariables,
    useFetchSystemVariable: baseCrud.useFetchOne,
    useCreateSystemVariable: baseCrud.useCreate,
    useUpdateSystemVariable: baseCrud.useUpdate,
    useRemoveSystemVariable: baseCrud.useRemove,

    //Extra
    useUploadSystemVariables,
    useSystemVariableOptions,
  }
}

export default useSystemVariable
